<template>
    <!-- DIALOG -->
    <CompassModal
        v-model:visible="showModal"
        size="small"
        :title="$t.__('utilities.AvatarUploader.image_modification')"
        class="avatar-uploader-dialog"
        @closed="$emit('close')"
    >
        <template #default>
            <div class="dialog__default">
                <p class="grey mt-0 mb-3 typographies-paragraph-medium-regular">
                    {{ $l10n.__('Sélectionnez une image') }}
                </p>

                <el-upload
                    ref="uploadAvatar"
                    name="qqfile"
                    :autoUpload="false"
                    :multiple="false"
                    class="avatar-uploader"
                    :action="route"
                    drag
                    :headers="headerInfo"
                    :showFileList="false"
                    :onChange="(file) => (pictureUploaded = file.raw)"
                    :onSuccess="onSuccess"
                >
                    <img
                        v-if="avatarCompute.value && avatarCompute.type === 'picture'"
                        :src="avatarCompute.value"
                    />
                    <p v-else class="el-upload__text typographies-paragraph-medium-regular">
                        {{ $l10n.__('Glissez - déposez une image ou cliquer') }}
                    </p>
                    <template #tip>
                        <p class="el-upload__tip typographies-paragraph-medium-regular">
                            ({{
                                $l10n.__(
                                    'Extension : jpg, jpeg, gif, png / Taille max : 15 Mo / Format recommandé : 400x400px',
                                )
                            }})
                        </p>
                    </template>
                </el-upload>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('utilities.AvatarUploader.delete_image')"
                    type="primary-destructive"
                    @click="removeImg"
                />
                <CompassButton
                    :label="$t.__('common.actions.save')"
                    type="primary"
                    class="ml-3"
                    @click="uploadAvatar"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
export default {
    props: {
        avatar: {
            type: [String, Object],
        },
        route: {
            type: String,
            required: false,
            default: '',
        },
        index: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            showModal: true,
            headerInfo: {
                'X-Requested-With': 'XMLHttpRequest',
                'X-REQUESTED-WITH-AXIOS': 1,
                'X-SAAS-WEBSERVICE': 1,
            },
            pictureUploaded: null,
        };
    },
    computed: {
        avatarCompute() {
            if (this.pictureUploaded) {
                return {
                    type: 'picture',
                    value: URL.createObjectURL(this.pictureUploaded),
                };
            }
            return typeof this.avatar === 'object' ? this.avatar : JSON.parse(this.avatar);
        },
    },
    methods: {
        uploadAvatar() {
            this.$refs.uploadAvatar.submit();
            this.$emit('close');
        },
        removeImg() {
            this.$ajax.del(this.route, {}, (res) => {
                EventBus.emit('modal:avatar-uploader:on-remove', { res: res, index: this.index });
                this.$emit('close');
            });
        },
        onChange(file) {
            EventBus.emit('modal:avatar-uploader:on-change', { file: file, index: this.index });
        },
        onSuccess(res, file) {
            EventBus.emit('modal:avatar-uploader:on-success', { res: res, file: file, index: this.index });
        },
    },
};
</script>

<style scoped lang="scss">
.avatar-uploader-dialog {
    .dialog {
        &__default {
            padding-bottom: 24px;
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}

.avatar-uploader .el-upload--text .el-upload-dragger .el-upload__text {
    margin: 0;
}
.el-upload-dragger img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>
